import { AuthService } from 'shared/lib/keycloak';

const getData = (lsKey: string) => {
  const storageData = localStorage.getItem(lsKey);
  return storageData ? JSON.parse(storageData) : {};
};

const getUserData = (lsKey: string) => {
  const userBk = AuthService.getUserBk();
  return userBk ? getData(lsKey)[userBk] : null;
};

const saveUserData = (lsKey: string, value: unknown) => {
  const id = AuthService.getUserBk();
  const usersObj = getData(lsKey);
  usersObj[id] = value;
  localStorage.setItem(lsKey, JSON.stringify(usersObj));
};

export const localStorageService = {
  getUserData,
  saveUserData,
};
